import {
  Button,
  Divider,
  Icon,
  ICONS_ENUM,
  Typography
} from '@sanlam-glacier/app-common/components';
import styles from './regulation-28-card-view.module.scss';
import { ViewFullBreakdownButton } from '../../atoms/view-full-breakdown-button/ViewFullBreakdownButton';
import { ExposureBreaches } from '../../atoms/exposure-breaches-cell/ExposureBreaches';
import { Reg28ClientBreachesResponseModelMock } from '../../../types/regulation-28/regulation-28.interfaces';

type Regulation28TableCardViewProps = {
  row: Reg28ClientBreachesResponseModelMock;
};

export const Regulation28ClientCard = ({ row }: Regulation28TableCardViewProps) => {
  const testComponentName = 'regulation28TableCardView';

  const firstBreach = row.exposureBreaches.slice(0, 1);
  const restOfBreaches = row.exposureBreaches.slice(1);

  return (
    <div className={styles.cardViewContainer}>
      <Button
        data-testid={`${testComponentName}ClientNameBtn`}
        className={styles.clientNameButton}
        size={Button.SIZE.MEDIUM}
        variant={Button.VARIANT.TERTIARY}
        color={Button.COLOR.NORMAL}
        endIcon={<Icon icon={ICONS_ENUM.NAVIGATION_ARROW_FORWARD} />}
      >
        {row.clientName}
      </Button>
      <Divider position={Divider.POSITION.HORIZONTAL} className={styles.cardViewDivider} />
      <div className={styles.cardInfo}>
        <Typography
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.MEDIUM}
        >{`Client ID`}</Typography>
        <Typography
          data-testid={`${testComponentName}ClientId`}
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.NORMAL}
        >
          {row.clientId}
        </Typography>
      </div>
      <Divider position={Divider.POSITION.HORIZONTAL} className={styles.cardViewDivider} />
      <div className={styles.cardInfo}>
        <Typography
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.MEDIUM}
        >{`Type of product`}</Typography>
        <Typography
          data-testid={`${testComponentName}ProductType`}
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.NORMAL}
        >
          {row.productType}
        </Typography>
      </div>
      <Divider position={Divider.POSITION.HORIZONTAL} className={styles.cardViewDivider} />
      <div className={styles.cardInfo}>
        <Typography
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.MEDIUM}
        >{`Days not compliant`}</Typography>
        <Typography
          data-testid={`${testComponentName}DaysNotCompliant`}
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.NORMAL}
        >
          {row.totalDaysNonCompliant}
        </Typography>
      </div>
      <Divider position={Divider.POSITION.HORIZONTAL} className={styles.cardViewDivider} />
      <div className={styles.cardInfo}>
        <Typography
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.MEDIUM}
        >{`Exposure breach`}</Typography>
        <ExposureBreaches firstBreaches={firstBreach} restOfBreaches={restOfBreaches} />
      </div>
      <Divider position={Divider.POSITION.HORIZONTAL} className={styles.cardViewDivider} />
      <div className={styles.viewFullBreakdownButtonContainer}>
        <ViewFullBreakdownButton
          clientName={row.clientName}
          exposureBreaches={row.exposureBreaches}
          exposureBreakdown={row.exposureBreakdown}
          buttonText='View breakdown'
        />
      </div>
    </div>
  );
};
